var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_vm._m(0),_c('div',{staticClass:"start"},[_vm._m(1),(_vm.haveIndexCheck)?_c('div',{staticClass:"btn ease",on:{"click":_vm.add}},[_vm._v("立即检测")]):_vm._e()])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require("@/assets/brand/checkLogo.png"),"alt":""}})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" 一键智能检测企业的税务风险，帮助企业提前发现涉税隐患，降低涉 "),_c('br'),_vm._v("税风险，同时提供解决方案。 ")])
}]

export { render, staticRenderFns }